export const environmentVariables = {
  baseApiUrl: import.meta.env.VITE_BASE_API_URL,
  nodeEnv: import.meta.env.VITE_NODE_ENV,
};
